import { render } from "./NewCharacter.vue?vue&type=template&id=779ec9fe&scoped=true"
import script from "./NewCharacter.vue?vue&type=script&lang=js"
export * from "./NewCharacter.vue?vue&type=script&lang=js"

import "./NewCharacter.vue?vue&type=style&index=0&id=779ec9fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-779ec9fe"]])

export default __exports__